import { useCallback, useEffect, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { IUploadFile } from './IUploadFile';
import { Grid } from '@mui/material';
import CustomisedDropDown from '../dropDown/dropDown';
import { IDocumentPropertiesResponse } from '../../models/income.model';
import { IDropDownResponse } from '../../models/registration.model';
import CustomisedDropDownimage from '../dropDown/dropDownimage';
import { requestPermission } from '../../utility/requestPermission';


export default function CustomisedUploadFile({ onFileChoosed, fileExtensions }: IUploadFile) {

    const [files, setFiles] = useState<File[]>([]);
    const [action, setAction] = useState<IDropDownResponse | null>(null);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const pdfInputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        if (action?.id === 1) {
            handleTakePhoto();
        } else if (action?.id === 2) {
            handleOpenFilePicker();
        } else if (action?.id === 3) {
            handleOpenPdfPicker();
        }
    }, [action]);

    const onDrop = useCallback((acceptedFiles: File[]) => {
        setFiles(acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file),
        })));
    }, []);

    const handleOpenFilePicker = () => {
        if (fileInputRef.current) {
            fileInputRef.current.removeAttribute('capture'); // Make sure capture is removed
            fileInputRef.current.setAttribute('accept', 'image/*'); // Set to accept images
            fileInputRef.current.value = '';
            fileInputRef.current.click();
        }
    };

    const handleTakePhoto = () => {
        if (fileInputRef.current) {
            fileInputRef.current.setAttribute('capture', 'environment'); // Set capture for the camera
            fileInputRef.current.setAttribute('accept', 'image/*'); // Ensure it accepts images
            fileInputRef.current.value = '';
            fileInputRef?.current?.click()!;
        }
    };


    useEffect(() => {

    }, [])
    //     try {
    //         const stream = await navigator.mediaDevices.getUserMedia({
    //             video: { facingMode: "user" },
    //             audio: false,
    //         });

    //         const video = document.createElement("video");
    //         video.playsInline = true;
    //         video.muted = true;
    //         video.srcObject = stream;
    //         await video.play();

    //         await new Promise<void>((resolve) => {
    //             const check = () => {
    //                 if (video.videoWidth > 0 && video.videoHeight > 0) resolve();
    //                 else requestAnimationFrame(check);
    //             };
    //             check();
    //         });

    //         const canvas = document.createElement("canvas");
    //         canvas.width = video.videoWidth;
    //         canvas.height = video.videoHeight;
    //         const ctx = canvas.getContext("2d");
    //         if (!ctx) throw new Error("Failed to get 2D context");

    //         ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    //         const blob = await new Promise<Blob | null>((resolve) =>
    //             canvas.toBlob(resolve, "image/jpeg", 0.95)
    //         );
    //         stream.getTracks().forEach((t) => t.stop());
    //         if (!blob) throw new Error("Failed to capture image");

    //         const file = new File([blob], `photo_${Date.now()}.jpg`, { type: "image/jpeg" });

    //         // ✅ Pass the new File to react-dropzone manually
    //         const event = {
    //             target: { files: [file] },
    //         } as unknown as React.ChangeEvent<HTMLInputElement>;

    //         // Simulate user selecting the file via input
    //         if (fileInputRef.current) {
    //             const dt = new DataTransfer();
    //             dt.items.add(file);
    //             fileInputRef.current.files = dt.files;
    //             fileInputRef.current.dispatchEvent(new Event("change", { bubbles: true }));
    //         }

    //         console.log("📸 Captured photo:", file);
    //     } catch (err) {
    //         console.error("Camera error:", err);
    //         if (err instanceof DOMException) {
    //             if (err.name === "NotAllowedError") alert("Camera permission denied.");
    //             else if (err.name === "NotFoundError") alert("No camera found on this device.");
    //             else alert("Camera error: " + err.message);
    //         } else alert("Unknown camera error.");
    //     }
    // };

    const handleOpenPdfPicker = () => {
        if (pdfInputRef.current) {
            pdfInputRef.current.removeAttribute('capture'); // Ensure capture is removed for PDF
            pdfInputRef.current.setAttribute('accept', 'application/pdf'); // Set to accept PDF files
            pdfInputRef.current.value = '';
            pdfInputRef.current.click();
        }
    };
    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            fileExtensions: fileExtensions ? fileExtensions?.some(item => item.includes('image')) ? [] : fileExtensions! : [],
        },
        onDrop,
        noClick: true,
        multiple: false,
    });

    useEffect(() => {
        if (files.length > 0) {
            onFileChoosed(files);
        }
    }, [files]);

    const generateDocumentOptions = () => {

        let image = fileExtensions?.some(item => item.includes('image'));
        let doc = fileExtensions?.some(item => item.includes('pdf'));
        const options: IDocumentPropertiesResponse[] = [];
        if (doc === true) {
            options.push({ id: 3, title: "مستند", enumName: "pdf", maxSize_KB: 0, additionalData: '', icon: "UploadFileOutlinedIcon" });
        }
        if (image === true) {
            options.push({ id: 1, title: "دوربین", enumName: "camera", maxSize_KB: 0, additionalData: '', icon: "CameraAltOutlinedIcon" });
            options.push({ id: 2, title: "گالری", enumName: "Gallery", maxSize_KB: 0, additionalData: '', icon: "PhotoLibraryOutlinedIcon" });
        }
        return options;
    };

    const documentOptions = generateDocumentOptions();

    const handleDropdownChange = (selectedItem: IDropDownResponse) => {
        setAction(selectedItem);
    };

    return (
        <div {...getRootProps()} className="imageUpload content-center" style={{ flexWrap: 'nowrap', display: 'flex' }}>

            <input {...getInputProps()}
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                accept="image/*"
                capture="environment"
            />
            <input {...getInputProps()}
                type="file"
                ref={pdfInputRef}
                style={{ display: 'none' }}
                accept="application/pdf"
            />
            <Grid container xs={12}>
                <CustomisedDropDownimage
                    title={""}
                    options={documentOptions}
                    label="بارگذاری فایل"
                    setSelectedItem={handleDropdownChange} // Use the new handler
                    isSelected={false}
                />
            </Grid>
        </div>
    );
}

